/**
 * Built-in scene / theme catalogs for validation hints (“expected one of …”).
 * Keep in sync with registerComponent / registerDashboard / registerAutomotive / diagram types.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
export var SHAPE_TYPES = [
    'rect',
    'circle',
    'ellipse',
    'line',
    'arc',
    'polygon',
    'polyline',
    'path',
    'star',
    'roundedRect',
    'text',
    'image',
    'sprite',
    'group',
    'layer',
];
export var UI_COMPONENT_TYPES = [
    'accordion',
    'button',
    'card',
    'checkbox',
    'dialog',
    'input',
    'label',
    'menu',
    'progressBar',
    'radio',
    'slider',
    'statusBar',
    'table',
    'tabs',
    'textarea',
    'toast',
    'toggle',
    'toolbar',
    'tooltip',
    'tree',
];
export var DASHBOARD_TYPES = [
    'alluvialChart',
    'areaChart',
    'bandChart',
    'barChart',
    'battery',
    'beeswarmChart',
    'boxAndWhiskerChart',
    'boxPlot',
    'bubbleChart',
    'bulletChart',
    'bumpChart',
    'calendar',
    'calendarHeatmap',
    'candlestickVolumeChart',
    'chartPanel',
    'chordChart',
    'clock',
    'columnChart',
    'combinationChart',
    'compass',
    'coneChart',
    'contourChart',
    'controlChart',
    'dendrogramChart',
    'densityPlot',
    'dotPlot',
    'doughnutChart',
    'errorBarChart',
    'funnelChart',
    'ganttChart',
    'gauge',
    'heatmap',
    'hexbinChart',
    'histogram',
    'horizonChart',
    'horizontalBarChart',
    'kagiChart',
    'knob',
    'legend',
    'lineChart',
    'lollipopChart',
    'marimekkoChart',
    'mekkoChart',
    'meshChart3d',
    'meter',
    'mixedChart',
    'mosaicChart',
    'networkChart',
    'parallelCoordinatesPlot',
    'paretoChart',
    'pictogramChart',
    'pieChart',
    'polarAreaChart',
    'populationPyramidChart',
    'pyramidChart',
    'qqPlot',
    'radarChart',
    'rangeAreaChart',
    'rangeChart',
    'ribbonChart',
    'ridgelinePlot',
    'runChart',
    'sankeyChart',
    'scatterChart',
    'signalStrength',
    'sparklineChart',
    'speedometer',
    'spiderChart',
    'splineChart',
    'stackedAreaChart',
    'stackedBarChart',
    'stackedColumnChart',
    'stemLeafPlot',
    'stepChart',
    'streamgraph',
    'stripPlot',
    'sunburstChart',
    'surfaceChart3d',
    'thermometer',
    'timeline',
    'treeChart',
    'treemap',
    'vectorFieldChart',
    'violinPlot',
    'volumeChart',
    'volumeProfileChart',
    'waffleChart',
    'waterfallChart',
    'wireframeChart3d',
    'wordCloudChart',
];
export var AUTOMOTIVE_TYPES = [
    'adasStatus',
    'albumArt',
    'batteryVoltage',
    'calendar',
    'callScreen',
    'canViewer',
    'climateControl',
    'compass',
    'cruiseControl',
    'digitalInstrumentCluster',
    'engineTemp',
    'fmRadio',
    'fuelGauge',
    'gearIndicator',
    'gpsNavigationMap',
    'headlights',
    'instrumentCluster',
    'mediaPlayer',
    'musicControls',
    'navigationSearch',
    'notificationCenter',
    'nowPlaying',
    'parkingBrake',
    'podcastPlayer',
    'quickSettingsPanel',
    'rearViewCamera',
    'routeGuidance',
    'speedometer',
    'sunriseSunset',
    'tachometer',
    'tpms',
    'turnIndicators',
    'warningAlertPanel',
    'warningLamp',
];
export var DIAGRAM_TYPES = [
    'flowchart',
    'stateMachine',
    'classDiagram',
    'mindMap',
    'networkTopology',
    'orgChart',
    'electricalSchematic',
    'schematicSymbolCatalog',
    'canNetwork',
    'processPipeline',
];
export var UI_THEME_PRESETS = [
    'default',
    'dark',
    'violet',
    'emerald',
    'slate',
    'ocean',
    'rose',
    'darkViolet',
];
export var AUTOMOTIVE_THEME_PRESETS = ['classic', 'sport', 'digital'];
/** Prop enums keyed by node type → prop name → allowed values */
export var PROP_ENUMS = {
    button: {
        variant: ['primary', 'secondary', 'ghost', 'danger'],
        size: ['sm', 'md', 'lg'],
    },
    progressBar: {
        variant: ['default', 'success', 'warning', 'danger'],
        size: ['sm', 'md', 'lg'],
    },
    checkbox: { size: ['sm', 'md', 'lg'] },
    toggle: { size: ['sm', 'md'] },
    toast: { variant: ['success', 'error', 'warning', 'info'] },
    tooltip: { placement: ['top', 'bottom', 'left', 'right'] },
    menu: {},
    // Automotive cluster theme (also accepted on other auto widgets)
    instrumentCluster: { theme: __spreadArray([], __read(AUTOMOTIVE_THEME_PRESETS), false) },
    digitalInstrumentCluster: { theme: __spreadArray([], __read(AUTOMOTIVE_THEME_PRESETS), false) },
    speedometer: { theme: __spreadArray([], __read(AUTOMOTIVE_THEME_PRESETS), false) },
    tachometer: { theme: __spreadArray([], __read(AUTOMOTIVE_THEME_PRESETS), false) },
    fuelGauge: { theme: __spreadArray([], __read(AUTOMOTIVE_THEME_PRESETS), false) },
    engineTemp: { theme: __spreadArray([], __read(AUTOMOTIVE_THEME_PRESETS), false) },
};
/** Shared prop enums applied to any node that declares the key */
export var SHARED_PROP_ENUMS = {
// string uiTheme presets (object uiTheme is also valid — skipped in enum check)
};
var KNOWN_TYPE_SET = new Set(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(SHAPE_TYPES), false), __read(UI_COMPONENT_TYPES), false), __read(DASHBOARD_TYPES), false), __read(AUTOMOTIVE_TYPES), false), __read(DIAGRAM_TYPES), false));
var extraTypes = new Set();
/** Register custom / plugin types so strict validation accepts them. */
export function registerKnownSceneTypes(types) {
    var e_1, _a;
    try {
        for (var types_1 = __values(types), types_1_1 = types_1.next(); !types_1_1.done; types_1_1 = types_1.next()) {
            var t = types_1_1.value;
            if (t)
                extraTypes.add(t);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (types_1_1 && !types_1_1.done && (_a = types_1.return)) _a.call(types_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
export function clearExtraSceneTypes() {
    extraTypes = new Set();
}
export function listKnownSceneTypes() {
    return __spreadArray(__spreadArray([], __read(KNOWN_TYPE_SET), false), __read(extraTypes), false).sort();
}
export function isKnownSceneType(type) {
    return KNOWN_TYPE_SET.has(type) || extraTypes.has(type);
}
/** Levenshtein distance (small strings). */
export function editDistance(a, b) {
    var m = a.length;
    var n = b.length;
    if (m === 0)
        return n;
    if (n === 0)
        return m;
    var prev = new Array(n + 1);
    var cur = new Array(n + 1);
    for (var j = 0; j <= n; j++)
        prev[j] = j;
    for (var i = 1; i <= m; i++) {
        cur[0] = i;
        for (var j = 1; j <= n; j++) {
            var cost = a[i - 1] === b[j - 1] ? 0 : 1;
            cur[j] = Math.min(cur[j - 1] + 1, prev[j] + 1, prev[j - 1] + cost);
        }
        for (var j = 0; j <= n; j++)
            prev[j] = cur[j];
    }
    return prev[n];
}
/**
 * Closest catalog matches for a bad value.
 * Prefers edit distance, then case-insensitive / substring hits.
 */
export function suggestClosest(value, allowed, limit) {
    if (limit === void 0) { limit = 5; }
    var v = String(value !== null && value !== void 0 ? value : '');
    if (!v || !allowed.length)
        return [];
    var lower = v.toLowerCase();
    var scored = allowed.map(function (cand) {
        var c = String(cand);
        var cl = c.toLowerCase();
        var score = editDistance(lower, cl);
        if (cl.startsWith(lower) || lower.startsWith(cl))
            score = Math.min(score, 1);
        if (cl.includes(lower) || lower.includes(cl))
            score = Math.min(score, 2);
        return { cand: c, score: score };
    });
    scored.sort(function (a, b) { return a.score - b.score || a.cand.localeCompare(b.cand); });
    var maxDist = Math.max(2, Math.ceil(v.length / 3));
    return scored
        .filter(function (s) { return s.score <= maxDist; })
        .slice(0, limit)
        .map(function (s) { return s.cand; });
}
/** `expected one of: "a" | "b" | "c"` (truncates long lists). */
export function formatExpectedValues(allowed, maxShow) {
    if (maxShow === void 0) { maxShow = 8; }
    var list = __spreadArray([], __read(allowed), false);
    if (list.length === 0)
        return 'expected a known value';
    if (list.length <= maxShow) {
        return "expected one of: ".concat(list.map(function (v) { return JSON.stringify(v); }).join(' | '));
    }
    var head = list.slice(0, maxShow).map(function (v) { return JSON.stringify(v); }).join(' | ');
    return "expected one of: ".concat(head, " | \u2026 (+").concat(list.length - maxShow, " more)");
}
/** Full human hint: invalid + expected + optional did-you-mean. */
export function formatInvalidValue(got, allowed, opts) {
    var _a;
    var maxShow = (_a = opts === null || opts === void 0 ? void 0 : opts.maxShow) !== null && _a !== void 0 ? _a : 8;
    var suggest = (opts === null || opts === void 0 ? void 0 : opts.suggest) !== false;
    var gotStr = typeof got === 'string' ? got : String(got);
    var expected = formatExpectedValues(allowed, maxShow);
    var parts = ["invalid value ".concat(JSON.stringify(gotStr), "; ").concat(expected)];
    if (suggest && typeof got === 'string') {
        var close_1 = suggestClosest(got, allowed, 3);
        if (close_1.length) {
            parts.push("did you mean ".concat(close_1.map(function (c) { return JSON.stringify(c); }).join(', '), "?"));
        }
    }
    return parts.join(' ');
}
export function propEnumsForType(type) {
    var _a;
    var specific = (_a = PROP_ENUMS[type]) !== null && _a !== void 0 ? _a : {};
    // Any auto widget may use theme: classic|sport|digital
    if (AUTOMOTIVE_TYPES.includes(type) && !specific.theme) {
        return __assign(__assign({}, specific), { theme: AUTOMOTIVE_THEME_PRESETS });
    }
    return specific;
}
